import React from "react";
import { useTranslation } from "react-i18next";
import "./StatusBadge.css";

const StatusBadge = ({ status }) => {
    const { t } = useTranslation();
    return (
        <span className={`status-badge status-badge--${status}`}>
            {t(`status.${status}`, status)}
        </span>
    );
};

export default StatusBadge;
